import React, {useCallback} from 'react'
import {Row, Col, CustomerDialogButtonRow} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {DialogDescription, DialogHeadline} from '../styles'

type ExitPromptDialogProps = {
  params: {
    handleConfirm: () => void
    handleCancel: () => void
    canSubmit: boolean
    isFinalStep: boolean
  }
  closeDialog: () => void
  dialogData: {
    loading: boolean
  }
}

const ExitPromptDialog: React.FC<ExitPromptDialogProps> = ({
  params,
  closeDialog,
  dialogData = {loading: false},
}) => {
  const {t} = useTranslation('charon')
  const {handleConfirm, handleCancel, canSubmit, isFinalStep} = params

  const handleSubmit = useCallback(() => {
    if (!canSubmit) {
      closeDialog()
    } else {
      handleConfirm()
    }
  }, [closeDialog, handleConfirm, canSubmit])

  return (
    <>
      <Row mt={30}>
        <Col col={10} offset={1}>
          <DialogHeadline>{t('exit-prompt.headline')}</DialogHeadline>
        </Col>
      </Row>
      <Row mt={20} mb={50}>
        <Col col={10} offset={1}>
          <DialogDescription>{t('exit-prompt.description')}</DialogDescription>
        </Col>
      </Row>
      <CustomerDialogButtonRow
        canSubmit={!dialogData?.loading}
        loading={!!dialogData?.loading}
        expectedSubmitDuration={2000}
        onSubmitClick={handleSubmit}
        submitText={
          canSubmit && isFinalStep
            ? t('exit-prompt.cta-submit')
            : t('exit-prompt.cta-continue-edit')
        }
        hasCancel
        canCancel={!dialogData?.loading}
        cancelText={t('exit-prompt.cta-cancel')}
        onCancelClick={handleCancel}
      />
    </>
  )
}

export default ExitPromptDialog
